import CameraIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/camera';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import STYLES from './ImageCaption.module.scss';

type ImageCaptionProps = {
  credit?: {
    label: string;
    altText: string;
  };
  description?: string;
  title?: string;
};

const ImageCaption = ({
  credit = undefined,
  description = '',
  title = '',
}: ImageCaptionProps) => {
  if (!(credit || description || title)) {
    return null;
  }

  return (
    <div className={STYLES.ImageCaption} data-testid="caption">
      {(title || description) && (
        <div>
          <BpkText tagName="p" textStyle={TEXT_STYLES.caption}>
            {title && (
              <span className={STYLES.Title}>
                <BpkText tagName="span" textStyle={TEXT_STYLES.label3}>
                  {title}
                </BpkText>
              </span>
            )}{' '}
            {description}
          </BpkText>
        </div>
      )}
      {credit && (
        <div className={STYLES.Credit}>
          <CameraIcon aria-hidden className={STYLES.Icon} />
          <BpkText
            tagName="p"
            textStyle={TEXT_STYLES.caption}
            aria-label={credit.altText}
          >
            {credit.label}
          </BpkText>
        </div>
      )}
    </div>
  );
};
export default ImageCaption;
